export interface UserInteraction {
  sessionId: string;
  userQuestion: string;
  agentResponse?: string;
  agentId?: string;
}

class AnalyticsService {
  private sessionId: string;
  private apiBaseUrl: string;

  constructor() {
    this.apiBaseUrl = '/api';
    this.sessionId = this.getOrCreateSessionId();
  }

  private getOrCreateSessionId(): string {
    let sessionId = sessionStorage.getItem('avatarSessionId');
    if (!sessionId) {
      sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      sessionStorage.setItem('avatarSessionId', sessionId);
    }
    return sessionId;
  }

  async trackUserInteraction(interaction: Omit<UserInteraction, 'sessionId'>): Promise<void> {
    try {
      const response = await fetch(`${this.apiBaseUrl}/user-interaction`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          sessionId: this.sessionId,
          userQuestion: interaction.userQuestion,
          agentResponse: interaction.agentResponse,
          agentId: interaction.agentId
        }),
      });

      if (!response.ok) {
        // Try to parse JSON, but handle cases where response is not JSON
        let errorMessage = 'Failed to track interaction';
        try {
          const data = await response.json();
          errorMessage = data.error || errorMessage;
        } catch {
          // If response is not JSON, just use the status text
          const text = await response.text();
          errorMessage = text || response.statusText || errorMessage;
        }
        console.warn(`⚠️ Analytics tracking failed (${response.status}): ${errorMessage}`);
        return; // Exit early, don't throw
      }

      console.log('✅ User interaction tracked successfully');
    } catch (error) {
      console.warn('⚠️ Analytics tracking error:', error);
      // Don't throw error to avoid disrupting the user experience
    }
  }

  getSessionId(): string {
    return this.sessionId;
  }

  clearSession(): void {
    sessionStorage.removeItem('avatarSessionId');
    this.sessionId = this.getOrCreateSessionId();
  }
}

export const analyticsService = new AnalyticsService();